import { ROLE_TYPE } from './Constant';
/**
 * 简单的权限管理
 *
 * @export
 * @class Permission
 */
export default class Permission {
  constructor() {
    this._role = -1;
    this.editable = false;
    this.pageable = false;
    this.cacheable = false;
    this.zoomable = false;
  }

  set role(r) {
    this._role = r;
  }

  get role() {
    return this._role;
  }

  get permission() {
    return PermissionMap[this.role] || PermissionMap[ROLE_TYPE.SPECTATOR];
  }
}

const PermissionMap = {
  [ROLE_TYPE.HOST]: {
    editable: true,
    pageable: true,
    cacheable: false,
    zoomable: true
  },
  [ROLE_TYPE.SPECTATOR]: {
    editable: false,
    pageable: false,
    cacheable: false,
    zoomable: true
  },
  [ROLE_TYPE.GUEST]: {
    editable: false,
    pageable: false,
    cacheable: false,
    zoomable: true
  },
  [ROLE_TYPE.ASSISTANT]: {
    editable: false,
    pageable: true,
    cacheable: false,
    zoomable: true
  }
};
